import StartScreen from "./components/StartScreen";
import BusinessSelect from "./components/Registration/BusinessSelect";
import SignUp from "./components/Registration/SignUp";
import EmailCheck from "./components/Registration/EmailCheck";
import Completed from "./components/Registration/Completed";
import PageError from "./components/PageError";
import { createBrowserRouter } from "react-router-dom";
import HealthCheckPage from "./components/HealthCheckPage";
import Terms from "./components/Terms";
import RedirectWithReferral from "./components/RedirectWithReferral";
import AffiliateLanding from "./components/Affiliate/AffiliateLanding";
import AffiliateSignup from "./components/Affiliate/AffiliateSignup";
import BrandCreationNew from "./components/Registration/BrandCreationNew";
import NewAnimatedCreation from "./components/Registration/NewAnimatedCreation";
import AdminInfo from "./components/Registration/AdminInfo";

const router = createBrowserRouter([
    {
        path: "/",
        element: <RedirectWithReferral />,
        errorElement: <PageError />,
    },
    {
        path: "/creation",
        element: <StartScreen />,
    },
    {
        path: "/creation/business",
        element: <BusinessSelect />,
    },
    { path: "/creation/brand", element: <BrandCreationNew /> },
    { path: "/creation/animated", element: <NewAnimatedCreation /> },
    { path: "/creation/admin-info", element: <AdminInfo /> },
    {
        path: "/creation/signup",
        element: <SignUp />,
    },
    {
        path: "/creation/email",
        element: <EmailCheck />,
    },
    {
        path: "/creation/completed",
        element: <Completed />,
    },
    {
        path: "/affiliate",
        element: <AffiliateLanding />,
    },
    {
        path: "/affiliate/signup",
        element: <AffiliateSignup />,
    },
    {
        path: "/health/check",
        element: <HealthCheckPage />,
    },
    {
        path: "/terms",
        element: <Terms />,
    },
]);

export default router;
